module.exports = __webpack_public_path__ + "img/P699205804.b4a535b8.jpg";